module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm3-c2e41b57dc3584a9c7534cdbe8626714.jpg";